<div class="layout-footer ui-g-12">
    <div class="ui-g">
        <div class="ui-g-12 ui-md-6 footer-left">
            <h3>Hydro NS</h3>
        </div>
    </div>
</div>
